export default "__VITE_ASSET__DTTtGFOD__"